module.exports = __webpack_public_path__ + "static/media/sumit.9c98cb8c.jpeg";